export class ClassTeacher {
  AccountID: number;
  Name: string;
  Email: string;
}

export class Class {
  ID?: number;
  Description?: string;
  StartingOn: string;
  Ending?: string;
  ClassSectionID?: number;
  CourseCode?: string;
  CourseDescription?: string;
  LoginCode?: string;
  StudentCount?: number;
  ExternalID?: string;
  TeacherID?: number;
  TeacherName?: string;
  Teachers: ClassTeacher[];
  Ended?: boolean;
  static getNew() {
    const c = new Class();
    c.StartingOn = '';
    c.Ending = '';
    c.LoginCode = '';
    return c;
  }
}
